/**
 * KYXTRO Theme JS (Local — Core Suite)
 * Consolidates foundational commerce and navigation logic.
 */

window.KYX = window.KYX || {};

/* ─── SHARED UTILITIES ─── */
KYX._escapeHtml = function (str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

KYX._money = function (cents) {
  var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : null;
  if (window.Shopify && window.Shopify.formatMoney && fmt) {
    return window.Shopify.formatMoney(cents, fmt);
  }
  return '&#8377;\u00a0' + parseFloat((cents / 100).toFixed(2)).toLocaleString('en-IN', { minimumFractionDigits: 2 });
};

/* ─── WISHLIST SHARED LOGIC ─── */
KYX._wishlist = {
  KEY: 'shopify_wishlist',
  load: function () {
    try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch (e) { return []; }
  },
  save: function (items) {
    try {
      localStorage.setItem(this.KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:change'));
    } catch (e) { }
  },
  has: function (id) {
    return !!this.load().find(function (i) { return String(i.id) === String(id); });
  },
  toggle: function (data) {
    var items = this.load();
    var exists = !!items.find(function (i) { return String(i.id) === String(data.id); });
    if (exists) {
      items = items.filter(function (i) { return String(i.id) !== String(data.id); });
      this.showNotification(data, true);
    } else {
      items.push(data);
      this.showNotification(data, false);
    }
    this.save(items);
    if (KYX.Wishlist && typeof KYX.Wishlist.render === 'function') KYX.Wishlist.render();
  },
  showNotification: function (data, removed) {
    var notif = document.getElementById('kyx-wishlist-notif');
    if (!notif) return;

    var img    = notif.querySelector('.kyx-wn-image img');
    var title  = notif.querySelector('.kyx-wn-title');
    var action = notif.querySelector('.kyx-wn-action');
    var btn    = notif.querySelector('.kyx-wn-btn');

    if (img)    img.src = data.image || '';
    if (title)  title.textContent = data.title || '';
    if (action) action.textContent = removed ? 'Item Removed' : 'Item Added';
    if (btn)    btn.style.display = removed ? 'none' : '';

    notif.classList.toggle('is-removed', !!removed);
    notif.classList.add('is-visible');

    if (this._notifTimeout) clearTimeout(this._notifTimeout);
    this._notifTimeout = setTimeout(function () {
      notif.classList.remove('is-visible');
    }, 3500);
  },
  syncButtons: function (scope) {
    var self = this;
    var ids = this.load().map(function (p) { return String(p.id); });
    var selector = '.js-wishlist-btn, .kfc-card__wish, .js-product-wishlist';
    var btns = scope ? scope.querySelectorAll(selector) : document.querySelectorAll(selector);

    btns.forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var saved = ids.indexOf(String(id)) > -1;
      btn.classList.toggle('is-wishlisted', saved);
      btn.classList.toggle('active', saved);
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');

      var path = btn.querySelector('path');
      if (path && btn.classList.contains('js-product-wishlist')) {
        if (saved) { path.setAttribute('fill', '#2563eb'); path.setAttribute('stroke', '#2563eb'); }
        else { path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); }
      }
      btn.classList.toggle('is-wishlisted', saved);
    });
  }
};

/* ─── CARD GALLERY SHARED LOGIC ─── */
KYX._cardGallery = {
  updateDots: function (card, ri, dotClass) {
    var dClass = dotClass || '.custom-card-dot';
    card.querySelectorAll(dClass).forEach(function (d, i) {
      var dist = Math.abs(i - ri);
      d.classList.remove('is-active', 'is-near1', 'is-near2');
      if (dist === 0) d.classList.add('is-active');
      else if (dist === 1) d.classList.add('is-near1');
      else if (dist === 2) d.classList.add('is-near2');
    });
  },
  bind: function (card, config) {
    if (card._galBound) return; card._galBound = true;
    var self = this;
    var total = parseInt(card.getAttribute('data-slide-count') || '1', 10); if (total <= 1) return;

    var trackClass = config.trackClass || '.custom-img-track';
    var dotClass   = config.dotClass || '.custom-card-dot';
    var prevClass  = config.prevClass || '.custom-card-arr--prev';
    var nextClass  = config.nextClass || '.custom-card-arr--next';
    var swipeClass = config.swipeClass || '.custom-card-link';

    var track = card.querySelector(trackClass); if (!track) return;
    var orig = Array.prototype.slice.call(track.children);
    var cf = orig[0].cloneNode(true), cl = orig[total - 1].cloneNode(true);
    cf.setAttribute('aria-hidden', 'true'); cl.setAttribute('aria-hidden', 'true');
    track.insertBefore(cl, track.firstChild); track.appendChild(cf);

    var tl = total + 2, pi = 1, ri = 0, anim = false;
    track.style.width = (tl * 100) + '%';
    Array.prototype.forEach.call(track.children, function (s) {
      s.style.flex = '0 0 ' + (100 / tl) + '%'; s.style.width = (100 / tl) + '%';
    });

    function setPos(idx, an) {
      track.style.transition = an ? 'transform 0.38s cubic-bezier(0.25,0.46,0.45,0.94)' : 'none';
      track.style.transform = 'translateX(' + (-(idx / tl) * 100) + '%)';
    }

    setPos(pi, false); self.updateDots(card, ri, dotClass);

    track.addEventListener('transitionend', function () {
      anim = false;
      if (pi === 0) { pi = total; setPos(pi, false); }
      else if (pi === total + 1) { pi = 1; setPos(pi, false); }
    });

    function slideTo(dir) {
      if (anim) return; anim = true; pi += dir; ri = ((pi - 1) % total + total) % total;
      setPos(pi, true); self.updateDots(card, ri, dotClass); card.setAttribute('data-slide', ri);
    }

    var prev = card.querySelector(prevClass), next = card.querySelector(nextClass);
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); slideTo(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); slideTo(1); });

    var sw = card.querySelector(swipeClass) || card.querySelector('.custom-product-image-wrapper') || card.querySelector('.bfc-card-img-wrap') || card.querySelector('.kfc-card__img-wrap');
    if (!sw) return;

    var tx = 0, ty = 0, swiping = false, did = false;
    sw.addEventListener('touchstart', function (e) {
      if (config.desktopOnly && window.innerWidth < 768) return;
      tx = e.touches[0].clientX; ty = e.touches[0].clientY; swiping = true; did = false;
    }, { passive: false });

    sw.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      var dx = Math.abs(e.touches[0].clientX - tx);
      var dy = Math.abs(e.touches[0].clientY - ty);
      if (!did && dx > dy && dx > 10) did = true;
      if (did) {
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    sw.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      if (!did) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 30) {
        slideTo(dx < 0 ? 1 : -1);
      }
      did = false;
    }, { passive: false });

    sw.addEventListener('click', function (e) { if (did) { e.preventDefault(); did = false; } });
  }
};

/* ─── HEADER MODULE (CORE) ─── */
KYX.Header = {
  init: function (config) {
    var self = this;
    var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var qsa = function (sel, ctx) { return (ctx || document).querySelectorAll(sel); };
    var lockScroll = function () { document.body.style.overflow = 'hidden'; };
    var unlockScroll = function () { document.body.style.overflow = ''; };

    var overlay = qs('.kyx-overlay');
    var menuDrawer = qs('.kyx-drawer--menu');
    var cartDrawer = qs('.cart-drawer');
    var megaPanel = qs('#kyx-mega-panel');
    var megaBackdrop = qs('#kyx-mega-backdrop');
    var openMenuBtn = qs('[data-testid="button-open-menu"]');
    var pillBtn = openMenuBtn;
    var headerWrap = qs('.kyx-header-wrap');

    window._kyxCartLabel = config.cartCheckoutLabel || 'CHECKOUT';
    window._kyxCartUrl = config.cartUrl || '/cart';

    /* ── Transparent header ── */
    (function () {
      if (!headerWrap) return;
      var ticking = false;
      var threshold = 300;
      
      window._kyxHeaderUpdateThreshold = function(el) {
        threshold = el ? (el.offsetHeight * 0.6) : 300;
      };

      function evalScroll() {
        if (headerWrap.getAttribute('data-transparent') === null) return;
        headerWrap.setAttribute('data-transparent', window.scrollY > threshold ? 'false' : 'true');
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(function () { evalScroll(); ticking = false; }); ticking = true; }
      }, { passive: true });
      
      window._kyxHeaderForceOpaque = function () { 
        if (headerWrap.getAttribute('data-transparent') !== null) headerWrap.setAttribute('data-transparent', 'false'); 
      };
      
      window._kyxHeaderRestoreTransp = function () { 
        if (window.scrollY <= threshold && headerWrap.getAttribute('data-transparent') !== null) {
          headerWrap.setAttribute('data-transparent', 'true'); 
        }
      };
    })();

    function setHeaderDrawerState(open, type) {
      if (!headerWrap) return;
      headerWrap.classList.toggle('drawer-open', open && type !== 'cart');
      headerWrap.classList.toggle('cart-drawer-open', open && type === 'cart');
    }

    function closeAll() {
      overlay && overlay.classList.remove('is-open');
      menuDrawer && menuDrawer.classList.remove('is-open');
      cartDrawer && cartDrawer.classList.remove('is-open');
      if (pillBtn) pillBtn.classList.remove('is-menu-open');
      unlockScroll();
      if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'true');
      if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
      setHeaderDrawerState(false);
      if (window._kyxHeaderRestoreTransp) window._kyxHeaderRestoreTransp();
    }

    var megaCloseTimer = null;
    var desktopHamBtn = qs('#kyx-desktop-ham-btn');
    var activeMegaPanel = null;

    function openMega(triggerName) {
      clearTimeout(megaCloseTimer);
      
      // Close all panels first
      qsa('.kyx-mega-panel').forEach(function (panel) {
        panel.classList.remove('is-open');
      });

      // Determine which panel to open
      var targetPanel = null;
      if (triggerName === 'default') {
        targetPanel = megaPanel;
      } else {
        targetPanel = qs('.kyx-mega-panel-style-1[data-trigger="' + triggerName + '"]');
      }

      if (targetPanel) {
        targetPanel.classList.add('is-open');
        activeMegaPanel = targetPanel;
      }
      if (megaBackdrop) megaBackdrop.classList.add('is-visible');
      qsa('.kyx-nav-link[data-mega]').forEach(function (btn) {
        var btnMega = btn.getAttribute('data-mega');
        if (btnMega === triggerName) {
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      if (triggerName === 'default') {
        if (desktopHamBtn) {
          desktopHamBtn.classList.add('is-mega-open');
          desktopHamBtn.setAttribute('aria-expanded', 'true');
        }
      }
      if (headerWrap) headerWrap.classList.add('mega-open');
    }

    function closeMega() {
      megaCloseTimer = setTimeout(function () {
        qsa('.kyx-mega-panel').forEach(function (panel) {
          panel.classList.remove('is-open');
        });
        activeMegaPanel = null;
        if (megaBackdrop) megaBackdrop.classList.remove('is-visible');
        qsa('.kyx-nav-link[data-mega]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
        qsa('.kyx-nav-item').forEach(function (item) { item.classList.remove('is-open'); });
        if (desktopHamBtn) { desktopHamBtn.classList.remove('is-mega-open'); desktopHamBtn.setAttribute('aria-expanded', 'false'); }
        if (headerWrap) headerWrap.classList.remove('mega-open');
        if (window._kyxHeaderRestoreTransp) window._kyxHeaderRestoreTransp();
      }, 120);
    }

    if (desktopHamBtn) {
      desktopHamBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (megaPanel && megaPanel.classList.contains('is-open')) closeMega();
        else { clearTimeout(megaCloseTimer); openMega('default'); }
      });
    }

    qsa('.kyx-nav-link[data-mega]').forEach(function (btn) {
      var triggerName = btn.getAttribute('data-mega');
      var isDefault = !isNaN(triggerName) && triggerName !== '';
      var finalTrigger = isDefault ? 'default' : triggerName.toLowerCase();

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var navItem = btn.closest('.kyx-nav-item');
        var targetPanel = isDefault ? megaPanel : qs('.kyx-mega-panel-style-1[data-trigger="' + finalTrigger + '"]');
        if (targetPanel && targetPanel.classList.contains('is-open') && navItem && navItem.classList.contains('is-open')) {
          closeMega(); if (navItem) navItem.classList.remove('is-open');
        } else {
          qsa('.kyx-nav-item').forEach(function (i) { i.classList.remove('is-open'); });
          if (navItem) navItem.classList.add('is-open');
          openMega(finalTrigger);
        }
      });

      btn.addEventListener('mouseenter', function () {
        clearTimeout(megaCloseTimer);
        var navItem = btn.closest('.kyx-nav-item');
        qsa('.kyx-nav-item').forEach(function (i) { i.classList.remove('is-open'); });
        if (navItem) navItem.classList.add('is-open');
        openMega(finalTrigger);
      });

      btn.addEventListener('mouseleave', closeMega);
    });

    qsa('.kyx-mega-panel').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
      panel.addEventListener('mouseleave', closeMega);
    });

    if (megaBackdrop) megaBackdrop.addEventListener('click', closeMega);

    function openMenu() {
      closeAll();
      menuDrawer && menuDrawer.classList.add('is-open');
      if (pillBtn) pillBtn.classList.add('is-menu-open');
      setHeaderDrawerState(true, 'menu');
      if (window._kyxHeaderForceOpaque) window._kyxHeaderForceOpaque();
      overlay && overlay.classList.add('is-open');
      lockScroll();
      if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'false');
    }

    if (openMenuBtn) {
      openMenuBtn.addEventListener('click', function (e) {
        if (e.target.closest('img') || e.target.closest('.kyx-pill-text')) { window.location.href = '/'; return; }
        if (menuDrawer && menuDrawer.classList.contains('is-open')) closeAll();
        else openMenu();
      });
    }

    function openCart() {
      closeAll();
      overlay && overlay.classList.add('is-open');
      cartDrawer && cartDrawer.classList.add('is-open');
      setHeaderDrawerState(true, 'cart');
      if (window._kyxHeaderForceOpaque) window._kyxHeaderForceOpaque();
      lockScroll();
      if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'false');
    }

    var openCartBtn = qs('[data-testid="button-open-cart"]');
    var closeCartBtn = qs('[data-testid="button-close-cart"]');
    if (openCartBtn) openCartBtn.addEventListener('click', openCart);
    if (closeCartBtn) closeCartBtn.addEventListener('click', closeAll);
    if (overlay) overlay.addEventListener('click', closeAll);

    qsa('.kyx-acc-item').forEach(function (item) {
      var btn = item.querySelector('.kyx-acc-btn');
      var plus = btn && btn.querySelector('span[aria-hidden]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        qsa('.kyx-acc-item').forEach(function (i) { i.classList.remove('is-open'); var icon = i.querySelector('.kyx-acc-btn span[aria-hidden]'); if (icon) icon.textContent = '+'; });
        if (!wasOpen) { item.classList.add('is-open'); if (plus) plus.textContent = '−'; }
      });
    });

    window.kyxCloseAll = closeAll;

    window.KYXCart = {
      refresh: function () {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          self.updateBubble(cart.item_count);
          self.renderCartBody(cart);
          return cart;
        });
      },
      open: openCart,
      close: closeAll,
      add: function (variantId, qty, properties) {
        var payload = { id: variantId, quantity: qty || 1 };
        if (properties) payload.properties = properties;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function () { return window.KYXCart.refresh(); })
          .then(function (cart) { openCart(); return cart; });
      },
      formatMoney: KYX._money
    };

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeMega(); }
    });

    this.bindCartEvents();
  },

  updateBubble: function (count) {
    var btn = document.querySelector('.kyx-cart-btn');
    var bubble = document.querySelector('.kyx-cart-count');
    if (count > 0) {
      if (!bubble) { bubble = document.createElement('span'); bubble.className = 'kyx-cart-count'; bubble.setAttribute('data-testid', 'text-cart-count'); if (btn) btn.appendChild(bubble); }
      bubble.textContent = count; bubble.style.display = 'inline-flex';
    } else if (bubble) { bubble.style.display = 'none'; }
  },

  renderCartBody: function (cart) {
    var heading = document.querySelector('.cart-drawer .kyx-drawer-title h2');
    if (heading) heading.textContent = cart.item_count === 0 ? 'Your bag is empty!' : 'Your bag is ready!';
    if (cart.item_count === 0) {
      this.renderEmptyState();
      return;
    }

    var html = '<div class="kyx-cart-items-container" data-testid="cart-filled">' +
      cart.items.map(this.renderCartItem).join('') +
      '<div class="kyx-cart-summary-bar" style="position:fixed;bottom:0;right:0;width:min(420px,100%);padding:1rem 1.5rem 1.5rem;background:var(--kyx-cart-bg);z-index:141;" data-testid="cart-summary">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.75rem;"><span style="font-size:13px;font-weight:700;color:#111;">Subtotal</span><span class="kyx-cart-subtotal" style="font-size:13px;font-weight:800;color:#111;">' + KYX._money(cart.total_price) + '</span></div>' +
      '<form action="' + (window._kyxCartUrl || '/cart') + '" method="post" id="cart-drawer-form">' +
      '<button type="submit" name="checkout" class="kyx-cart-checkout-btn" style="width: 100%; border: none; cursor: pointer;" data-checkout-label>' + (window._kyxCartLabel || 'CHECKOUT') + '</button>' +
      '</form>' +
      '</div></div>';

    var body = document.querySelector('.cart-drawer .kyx-drawer-body');
    if (body) { body.innerHTML = html; this.bindCartEvents(); }
  },

  renderCartItem: function (item, index) {
    var varLabel = (item.variant_title && item.variant_title !== 'Default Title') ? '<div style="font-size:12px;color:#6b7280;margin-top:.25rem;">' + item.variant_title + '</div>' : '';
    var imgHtml = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy">' : '';
    return '<div class="kyx-cart-item" data-line="' + (index + 1) + '" data-key="' + item.key + '">' +
      '<a href="' + item.url + '" style="width:84px;height:100px;border-radius:14px;overflow:hidden;background:#e5e7eb;display:block;flex:0 0 auto;">' + imgHtml + '</a>' +
      '<div style="flex:1;min-width:0;position:relative;">' +
      '<div style="display:flex;justify-content:space-between;gap:1rem;"><div style="min-width:0;"><div style="font-weight:700;font-size:14px;letter-spacing:-0.02em;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.product_title + '</div>' + varLabel + '</div><div style="font-weight:700;font-size:13px;color:#111;">' + KYX._money(item.final_line_price) + '</div></div>' +
      '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:.75rem;">' +
      '<div style="display:inline-flex;align-items:center;gap:.5rem;background:rgba(0,0,0,.05);border-radius:9999px;padding:.35rem .55rem;">' +
      '<button type="button" class="kyx-qty-btn kyx-qty-minus" style="border:0;background:transparent;cursor:pointer;">−</button>' +
      '<span class="kyx-qty-text" style="min-width:16px;text-align:center;font-weight:700;font-size:12px;">' + item.quantity + '</span>' +
      '<button type="button" class="kyx-qty-btn kyx-qty-plus" style="border:0;background:transparent;cursor:pointer;">+</button>' +
      '</div>' +
      '<button type="button" class="kyx-remove-btn" style="border:0;background:transparent;cursor:pointer;font-size:12px;color:#6b7280;">Remove</button>' +
      '</div></div></div>';
  },

  bindCartEvents: function () {
    var container = document.querySelector('.kyx-cart-items-container'); if (!container) return;
    var self = this;
    
    // Use a simple flag to prevent overlapping renders while allowing quick clicks
    this._cartUpdating = false;

    container.onclick = function (e) {
      var minus = e.target.closest('.kyx-qty-minus'), plus = e.target.closest('.kyx-qty-plus'), remove = e.target.closest('.kyx-remove-btn');
      if (!minus && !plus && !remove) return;
      
      var item = e.target.closest('.kyx-cart-item');
      var line = parseInt(item.getAttribute('data-line'));
      var qtyEl = item.querySelector('.kyx-qty-text');
      var qty = parseInt(qtyEl.textContent);
      
      var target = remove ? 0 : (plus ? qty + 1 : qty - 1);
      if (target < 0) return;

      // --- OPTIMISTIC UI: Update instantly ---
      if (!remove) {
        qtyEl.textContent = target;
        // Visual feedback that it's "syncing"
        qtyEl.style.opacity = '0.5';
      }

      // Add loading state to remove button
      var removeBtn = item.querySelector('.kyx-remove-btn');
      if (removeBtn) removeBtn.classList.add('is-loading');

      var resetLoading = function() {
        if (removeBtn) removeBtn.classList.remove('is-loading');
        if (qtyEl) qtyEl.style.opacity = '1';
      };

      fetch('/cart/change.js', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ line: line, quantity: target }) 
      })
      .then(function (r) { 
        if (!r.ok) return r.json().then(function(err) { throw err; });
        return r.json(); 
      })
      .then(function (cart) { 
        self.updateBubble(cart.item_count); 
        self.renderCartBody(cart); 
      })
      .catch(function(err) {
        console.error('Cart update error:', err);
        resetLoading();
        // Revert quantity UI on error
        if (qtyEl) qtyEl.textContent = qty;
        if (err.description) alert(err.description);
      });
    };
  },

  renderEmptyState: function () {
    var body = document.querySelector('.cart-drawer .kyx-drawer-body');
    var summary = document.querySelector('.kyx-cart-summary-bar');
    var template = document.getElementById('kyx-cart-empty-template');

    if (body && template) {
      body.innerHTML = template.innerHTML;
    }
    if (summary) summary.style.display = 'none';
  }
};

/* ─── PRODUCT & COMMERCE MODULES (CORE) ─── */
KYX.Product = {
  init: function (config) {
    var selectedVariantId = config.currentVariantId;
    KYX._wishlist.syncButtons();
    // Initial state check - if no variant buttons exist (no real variants), infer from the ATC button's disabled state
    var activeVariantBtn = document.querySelector('.variant-btn.active');
    var initialAvailable = activeVariantBtn 
      ? activeVariantBtn.getAttribute('data-available') === 'true'
      : !(document.querySelector('.product-actions-wrapper .add-to-cart')?.disabled);
    var initialPreorder = activeVariantBtn
      ? activeVariantBtn.getAttribute('data-is-preorder') === 'true'
      : false;
    var isCurrentVariantPreorder = initialPreorder;
    
    updateSoldOutUI(initialAvailable, initialPreorder);
    document.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedVariantId = this.getAttribute('data-variant-id');
        var isAvailable = this.getAttribute('data-available') === 'true';
        var isPreorder = this.getAttribute('data-is-preorder') === 'true';
        isCurrentVariantPreorder = isPreorder;
        
        // Update pills
        document.querySelectorAll('.variant-btn').forEach(function (b) { 
          b.classList.toggle('active', b.getAttribute('data-variant-id') === selectedVariantId); 
        });
        
        // Update price
        var p = this.getAttribute('data-price'); 
        if (document.getElementById('price-desktop')) document.getElementById('price-desktop').innerText = p;

        updateSoldOutUI(isAvailable, isPreorder);
      });
    });

    function updateSoldOutUI(isAvailable, isPreorder) {
      // Toggle Sold Out states
      document.querySelectorAll('[data-product-box-wrapper], [data-product-box], [data-mobile-gallery-wrapper], [data-buy-buttons-wrapper]').forEach(function(el) {
        el.classList.toggle('is-sold-out', !isAvailable);
      });

      // Update button states
      document.querySelectorAll('.add-to-cart, .buy-now').forEach(function(b) {
        b.disabled = !isAvailable;
        if (b.classList.contains('add-to-cart')) {
          b.innerText = isPreorder ? 'PRE-ORDER' : (isAvailable ? 'ADD TO BAG' : 'SOLD OUT');
        }
      });
    }
    document.querySelectorAll('.add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var originalHTML = btn.innerHTML;
        var w = btn.offsetWidth;
        var h = btn.offsetHeight;
        
        btn.style.width = w + 'px';
        btn.style.height = h + 'px';
        btn.style.padding = '0';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.pointerEvents = 'none';

        btn.innerHTML = '<svg style="animation:kyx-spin 1s linear infinite;" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>';
        
        var properties = isCurrentVariantPreorder ? { _Preorder: 'True' } : null;
        if (window.KYXCart) {
          window.KYXCart.add(Number(selectedVariantId), 1, properties).finally(function() {
            btn.innerHTML = originalHTML;
            btn.style.width = '';
            btn.style.height = '';
            btn.style.padding = '';
            btn.style.display = '';
            btn.style.alignItems = '';
            btn.style.justifyContent = '';
            btn.style.pointerEvents = 'auto';
          });
        }
      });
    });
    document.querySelectorAll('.buy-now').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var originalHTML = btn.innerHTML;
        btn.innerHTML = '<svg style="animation:kyx-spin 1s linear infinite; margin-right: 6px; vertical-align: middle;" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg> <span style="vertical-align: middle;">PROCESSING...</span>';
        btn.style.pointerEvents = 'none';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(selectedVariantId), quantity: 1 })
        }).then(function() {
          window.location.href = '/checkout';
        }).catch(function() {
          btn.innerHTML = originalHTML;
          btn.style.pointerEvents = 'auto';
        });
      });
    });
  }
};

KYX.Wishlist = {
  init: function () {
    this.render();
  },
  render: function () {
    var self = this;
    var container = document.getElementById('WishlistGrid');
    var emptyMsg = document.getElementById('WishlistEmpty');
    var loader = document.getElementById('WishlistLoader');
    var countEl = document.getElementById('WishlistCount');
    if (!container) return;

    var items = KYX._wishlist.load();
    if (loader) loader.style.display = 'none';

    if (countEl) {
      countEl.textContent = items.length + ' item' + (items.length !== 1 ? 's' : '') + ' saved';
    }

    if (items.length === 0) {
      if (container) container.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';
    
    var html = '';
    items.forEach(function (p) {
      html += `
        <div class="custom-product-card" data-product-id="${p.id}">
          <div class="custom-product-image-wrapper">
            <a href="${p.url}" class="custom-card-link" style="position:absolute;inset:0;z-index:1;display:block;" tabindex="-1" aria-hidden="true"></a>
            <div class="custom-img-track">
               <img src="${p.image}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">
            </div>
            <button type="button" class="wishlist-remove js-wishlist-remove" data-product-id="${p.id}" aria-label="Remove item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
          </div>
          <div class="custom-product-info">
            <div style="flex:1;">
              <a href="${p.url}" style="text-decoration:none;"><h3 class="custom-product-title">${p.title}</h3></a>
              <p class="custom-product-price">${p.price}</p>
            </div>
            <button type="button" class="custom-quick-buy-btn kyx-qa-trigger" 
              data-product-title="${p.title.replace(/"/g, '&quot;')}" 
              data-product-price="${p.price}" 
              data-product-url="${p.url}" 
              data-variants="${JSON.stringify(p.variants).replace(/"/g, '&quot;')}" 
              aria-label="Quick add ${p.title.replace(/"/g, '&quot;')}">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            </button>
          </div>
        </div>
      `;
    });
    container.innerHTML = html;

    container.querySelectorAll('.js-wishlist-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = this.getAttribute('data-product-id');
        KYX._wishlist.toggle({ id: id });
        self.render();
      });
    });
  }
};

KYX.Collection = {
  init: function (el, config) {
    if (!el) return;
    var sid = config.sectionId;
    var openBtn = document.getElementById('col-filter-open-' + sid);
    var closeBtn = document.getElementById('col-drawer-close-' + sid);
    var overlay = document.getElementById('col-drawer-overlay-' + sid);
    var drawer = document.getElementById('col-drawer-' + sid);
    var applyBtn = document.getElementById('col-drawer-apply-' + sid);

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.onclick = openDrawer;
    if (closeBtn) closeBtn.onclick = closeDrawer;
    if (overlay) overlay.onclick = closeDrawer;

    if (applyBtn) {
      applyBtn.onclick = function() {
        var params = new URLSearchParams(window.location.search);
        var min = document.getElementById('col-price-min-' + sid);
        var max = document.getElementById('col-price-max-' + sid);
        var sort = document.getElementById('col-drawer-sort-' + sid);

        if (min && min.value) params.set(min.name, min.value);
        if (max && max.value) params.set(max.name, max.value);
        if (sort) params.set('sort_by', sort.value);

        window.location.search = params.toString();
      };
    }

    el.querySelectorAll('.custom-product-card').forEach(function (card) { KYX._cardGallery.bind(card, {}); });
    KYX._wishlist.syncButtons(el);
  }
};

KYX.FeaturedCollection = {
  init: function (el, config) {
    if (!el) return;
    el.querySelectorAll('.custom-product-card').forEach(function (card) { KYX._cardGallery.bind(card, {}); });
    KYX._wishlist.syncButtons(el);
  }
};

KYX.FeaturedSlider = {
  init: function (el) {
    if (!el) return;
    el.querySelectorAll('.bfc-card').forEach(function (card) { KYX._cardGallery.bind(card, { trackClass: '.bfc-img-track', dotClass: '.bfc-dot', prevClass: '.bfc-arr--prev', nextClass: '.bfc-arr--next', swipeClass: '.bfc-card-bg-link', desktopOnly: true }); });
  }
};

KYX.RelatedProducts = {
  init: function (el, config) {
    if (!el) return;
    var pid = config.productId;
    if (!pid) return;

    var sectionId = config.sectionId;
    var limit = config.limit || 8;
    var url = '/recommendations/products?section_id=' + sectionId + '&product_id=' + pid + '&limit=' + limit;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.rp-inner-wrap');
        var oldInner = el.querySelector('.rp-inner-wrap');

        if (newInner && oldInner) {
          if (newInner.innerHTML.trim().length > 0) {
            oldInner.innerHTML = newInner.innerHTML;
            oldInner.style.display = 'block';

            // Re-bind galleries for newly injected cards
            el.querySelectorAll('.custom-product-card').forEach(function (card) {
              KYX._cardGallery.bind(card, {});
            });

            // Sync wishlist buttons
            KYX._wishlist.syncButtons(el);
          } else {
            // If no recommendations and no manual products (oldInner might have had manual ones)
            // We check if the new inner actually has any product cards
            if (newInner.querySelectorAll('.custom-product-card').length === 0 && oldInner.querySelectorAll('.custom-product-card').length === 0) {
              oldInner.style.display = 'none';
            }
          }
        }
      })
      .catch(function (err) { console.error('KYX Recommendations error:', err); });
  }
};

KYX.TransparentHeader = function (el) {
  var headerWrap = document.querySelector('.kyx-header-wrap');
  if (headerWrap) {
    headerWrap.setAttribute('data-transparent', 'true');
    if (window._kyxHeaderUpdateThreshold) window._kyxHeaderUpdateThreshold(el);
    if (window._kyxHeaderRestoreTransp) window._kyxHeaderRestoreTransp();
  }
};

/* ─── STARTUP SEQUENCE ─── */
document.addEventListener('DOMContentLoaded', function () {
  KYX._wishlist.syncButtons();
  KYX.Wishlist.init();

  // Global Wishlist Delegation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-wishlist-btn, .custom-wishlist-btn, .kfc-card__wish, .js-product-wishlist');
    if (btn) {
      e.preventDefault();
      // e.stopImmediatePropagation(); // Removed to allow other potential listeners
      
      var id = btn.getAttribute('data-product-id') || btn.dataset.productId;
      if (!id) return;

      var variants = [];
      try {
        var vData = btn.getAttribute('data-variants') || btn.dataset.variants;
        if (vData) {
          // If vData already looks like JSON (starts with [ or {), parse it
          if (typeof vData === 'string' && (vData.indexOf('[') === 0 || vData.indexOf('{') === 0)) {
             variants = JSON.parse(vData.replace(/&quot;/g, '"'));
          } else if (Array.isArray(vData)) {
             variants = vData;
          }
        }
      } catch (err) { }

      KYX._wishlist.toggle({
        id: id,
        title: btn.getAttribute('data-product-title') || btn.dataset.productTitle || '',
        price: btn.getAttribute('data-product-price') || btn.dataset.productPrice || '',
        image: btn.getAttribute('data-product-image') || btn.dataset.productImage || '',
        url: btn.getAttribute('data-product-url') || btn.dataset.productUrl || '',
        variants: variants
      });
    }
  }, true); // Use capture phase to beat other listeners

  window.__KXCoreReady__ = true;
  window.dispatchEvent(new CustomEvent('kyx:core:ready'));

  window.addEventListener('wishlist:change', function () { KYX._wishlist.syncButtons(); });
  window.addEventListener('storage', function (e) { if (e.key === KYX._wishlist.KEY) KYX._wishlist.syncButtons(); });
});
